import "./App.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import MainAuth from "./auth/MainAuth";
import Dashboard from "./pages/dashboard/Dashboard";
import Customer from "./pages/customer/Customer";
import Layout from "./pages/Layout";
import JournalReport from "./pages/reports/JournalReport";
import Users from "./pages/users/Users";
import Settings from "./pages/settings/Settings";
import Companies from "./pages/companies/Companies";
import ProtectedRoutes from "./ProtectedRoutes";
import CustomerTransactions from "./pages/customer/CustomerTransactions";


function App() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainAuth />} />
          <Route element={<ProtectedRoutes />}>
            <Route path="/companies" element={<Layout><Companies /></Layout>} />
            <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
            <Route path="/customers" element={<Layout><Customer /></Layout>} />
            <Route path="/report" element={<Layout><JournalReport /></Layout>} />
            <Route path="/users" element={<Layout><Users /></Layout>} />
            <Route path="/settings" element={<Layout><Settings /></Layout>} />
            <Route path="/customer-transactions" element={<Layout><CustomerTransactions/></Layout>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;